import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from 'prop-types';
import DashboardTopBar from './DashboardTopBar';
import BlueprintTopBar from './BlueprintTopBar';
import FixedDrawer from './Drawer';
import SideBar from './SideBar';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Colors from '../../config/colors';
import AutoSave from "../../components/atoms/autosave";
import { getAiAssistant, getSavingInProgress } from '../../store/global/selectors';
import { ApiResponseAlert } from '../../components/molecules/alerts/ApiResponseAlert';
import UploadNotifications from '../../components/molecules/assets/UploadNotifications';
import { collapsableSidebarStatus, setReRender } from '../../store/global/actions';
import PromptModal from '../../components/molecules/PromptModal/PromptModal';
import AIAssistanceModal from '../../components/molecules/AIAssistance/AIAssistanceModal';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    //marginTop: 62,
    height: '100vh',
    overflow: 'auto',
    backgroundColor: Colors.hyperBlox.backgroundColor || '#fff',
  },
}));

function Layout(props) {
  const classes = useStyles();
  const savingInProgress = useSelector(getSavingInProgress);
  const [open, setOpen] = React.useState(true);
  const dispatch = useDispatch();
  const aiAssistantData = useSelector(getAiAssistant)

  const isPathBlueprint = props.location.pathname.indexOf('/blueprint/') > -1;
  function updateBottomDrawerWidth(open) {
    const sidebar_width = 171;
    const drawer = document.getElementById('bottom_drawer_container');
    if (!drawer) return;
  
    if (open) {
      drawer.style.width = `calc(100vw - 64px - ${sidebar_width})`;
    } else {
      drawer.style.width = "calc(100vw - 64px)";
    }
  }

  const handleToggleSideBar = () => {
    updateBottomDrawerWidth(open)
    dispatch(setReRender());
    setOpen(!open);
    dispatch(collapsableSidebarStatus(!open))
  };

  useEffect(() => {
    updateBottomDrawerWidth(open);
  })

  return (
    <>
      <div className={classes.root}>
        <CssBaseline />
        <UploadNotifications/>
        {isPathBlueprint ? <BlueprintTopBar /> : <DashboardTopBar />}
        {/* {isPathBlueprint && <PromptModal />} */}
        <FixedDrawer drawerOpen={open} toggleSideDrawer={handleToggleSideBar} />
        {isPathBlueprint && <SideBar drawerOpen={open} toggleSideDrawer={handleToggleSideBar} />}
        <main className={classes.content} id="main-content-div">
          {isPathBlueprint ? null : <div className={classes.appBarSpacer} />}
          {isPathBlueprint && savingInProgress === true && <AutoSave />}
          {props.children}
        </main>
        <ApiResponseAlert />
        {
          isPathBlueprint &&
          <AIAssistanceModal open={aiAssistantData?.promptModalOpen}/>
        }
      </div>

    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {
  children: <React.Fragment />,
};

export default withRouter(Layout);
